// extracted by mini-css-extract-plugin
module.exports = {"comp":"JI_comp__J9T1Y"};